export default __webpack_public_path__ + "static/media/d42dd843-62b0-4623-8855-d5882512c3c9.05879370.woff";